import { IPurchaserRequest } from "../../Orchestrator/Types/Interface/IPurchaserRequest";
import { IPurchaserResponse } from "../../Orchestrator/Types/Interface/IPurchaserResponse";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function patchPurchaser(
  bookingId: string,
  purchaserRequest: IPurchaserRequest,
  showLoader?: boolean
): Promise<IApiResponse<IPurchaserResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = `${ENDPOINTS.patchPurchaser}/${bookingId}/purchaser`;
  return await apiRequest<IPurchaserResponse>(endpoint, "PATCH", {
    body: JSON.stringify(purchaserRequest),
  }, 'none', undefined, undefined, showLoader);
}
